import { HStack,Image,VStack } from '@chakra-ui/react'
import logo from 'assets/wicar/main_logo.png'

export const HeaderLogo = () => {
  return (
    <VStack flex={1} w="full">
      <HStack flex={1} alignItems="center" justifyContent="center">
        <Image
          src={logo}
          height={'full'}
          alt={'loading_wicar'}
        />
      </HStack>
    </VStack>
  )
}
